import { differenceInWeeks, format } from 'date-fns';

import type { FullContest } from '~/domains/contest/domains/services/interfaces/full-contest.interface';
import type { ContestSlate } from '~/domains/games/interfaces/contest.slates.interface';

function getPicksLabelBar(contest: FullContest, slate: ContestSlate): string | null {
  const pickDeadlineType = contest.settings?.pickDeadlineType;

  if (pickDeadlineType === 'game') {
    return 'At the start of each game';
  }

  const lockDate = new Date(slate.picksLockAt ?? slate.startDate);
  if (lockDate < new Date()) {
    return format(lockDate, 'MMM d yyyy, h:mm a');
  }

  const diffInWeeks = differenceInWeeks(new Date(), lockDate);
  if (diffInWeeks < 1) {
    return format(lockDate, 'EEE, h:mm a');
  }
  return format(lockDate, 'MMM d, h:mm a');
}

export default getPicksLabelBar;
